import * as types from './mutation-types';

export const toggleDebugMode = ({ commit }, val) => {
  console.log('toggleDebugMode');
  console.log(val);
  commit(types.TOGGLE_DEBUG_MODE, val);
};

export const toggleNotifications = ({ commit }, config) => {
  if (config instanceof Object) {
    commit(types.TOGGLE_NOTIFICATIONS, config);
  }
};

export const clearSiteNotifications = ({ commit }) => {
  commit(types.CLEAR_SITE_NOTIFICATIONS);
};

export const parseOrganisationNotifications = ({ commit }, data) => {
  commit(types.SOCKET_SITEUPDATENOTIFICATION, data);
};

export const parsePluginUpdateNotifications = ({ commit }, data) => {
  commit(types.SOCKET_PLUGINUPDATENOTIFICATION, data);
};

export const parseSiteBackupNotifications = ({ commit }, data) => {
  commit(types.SOCKET_BACKUPUPDATENOTIFICATION, data);
};

export const parseOrganisationThemeUpdateNotifications = ({ commit }, data) => {
  commit(types.SOCKET_SITETHEMEUPDATENOTIFICATION, data);
};

export const queueSiteUpdate = ({ commit }, data) => {
  commit(types.QUEUE_SITE_UPDATE, data);
};

export const addErrorMessage = ({ commit }, message) => {
  if (config instanceof Object) {
    commit(types.ADD_ERROR_MESSAGE, message);
  }
};
